// extracted by mini-css-extract-plugin
export default {"BaseCell":"linked-pull-requests-group-module__BaseCell__wzcsD6U"};